import React from 'react';
import { motion } from 'framer-motion';
import { floorToInt } from '../lib/utils';
import { useCountdownTime } from './CountdownTimer';

const TotalPeopleSolved = ({ count = 847 }) => {
  const time = useCountdownTime();
  const formattedTime = [
    time.hours,
    time.minutes,
    time.seconds,
  ].map((part) => String(part).padStart(2, '0')).join(' : ');

  return (
    <motion.div
      className="glass-panel rounded-[24px] px-5 py-6 text-center"
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: 'spring', stiffness: 300, damping: 24, delay: 0.1 }}
    >
      <p className="text-sm text-[#666666] mb-2 font-['DM_Sans']">
        Total People Solved
      </p>
      <div className="text-6xl font-bold text-gradient font-['Outfit'] mb-2 leading-none">
        {floorToInt(count)}
      </div>
      <p className="text-xs text-[#666666] font-['DM_Sans']">
        Live count • Updating in real time
      </p>
      <p className="mt-2 text-[11px] sm:text-xs font-semibold tracking-[0.08em] uppercase text-[#666666] font-['DM_Sans'] whitespace-nowrap">
        Time left • <span className="digital-clock text-[#111111] tracking-[0.12em]">{formattedTime}</span>
      </p>
    </motion.div>
  );
};

export default TotalPeopleSolved;
